import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DOCUMENT_TYPE_CONFIG } from "./apiRoutes";

interface UseGetDcoTypeByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDocumentTypeById = async (id: string) =>
  await axiosAuth.get(`${DOCUMENT_TYPE_CONFIG}/${id}`);

const useGetDocumentTypeById = ({
  id,
  queryParams,
}: UseGetDcoTypeByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["document-type", id],
    queryFn: () => getDocumentTypeById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetDocumentTypeById;
